export type IReporteCompraResp = {
  code: number
  count: number
  data: ReporteCompra[]
}
export type IReporteCompraParams = Omit<Partial<ReporteCompra>, 'proveedor'> & {
  page?: number
  page_size?: number
  codigo_proveedor?: string
  descripcion_producto: string
  razon_social_proveedor: string
  fecha_desde: string
  fecha_hasta: string
  numero_factura: string
  numero_guia_remision: string
}
export type ReporteCompra = {
  cantidad: string
  producto: Producto
  proveedor: Proveedor
  ingreso: IngresoInventario
  series: string[]
  orden_compra: ordenCompra
  series_data?: string[]
  producto_data?: string[]
  precio_compra?: string
  ultimo_precio_compra?: string
  total_precio_compra?: string
  cantidad_aprobada?: string
}
export type IngresoInventario = {
  numero_factura: string
  numero_guia_remision: string
  fecha_creacion: string
}

export type Proveedor = {
  razon_social: string;
}

export type Producto = {
  codigo: string
  descripcion: string
  presentacion: string 
  metros_base: number
  usa_metros: number
  metros_actuales:number
  stock_actual: string
}
export type ordenCompra = {
  total: string
  codigo: string
  detalle: {
    cantidad_aprobada: string
  }[]
}
export enum EnumChoiceOptions {
  descripcion_producto = 'PRODUCTO',
  numero_factura = 'NÚMERO FACTURA',
  numero_guia_remision = 'NÚMERO REMISION',
  razon_social_proveedor = 'PROVEEDOR'
}
